// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"ZL4Vw","items":"wqWJ3","item":"xFrXc","value":"omlwP","icon":"RjhWk"};